const simulatorConfig = {
  ANATOMICAL: 'anatomical',
  RUN_INFO: 'run_info',
  OUTER_FOV_RATIO: 'outer_fov_ratio',
  PERFORMANCE_GRIDZ_SLICE_THICKNESS: 'performance_gridZ_sliceThickness',
  ANALYTICAL_SIMULATION: 'analytical_simulation',
  FAST_ALGORITHM: 'fast_algorithm',
  MONITOR_PERFORMACE: 'monitor_performance',
  ANATOMICAL_MODEL_RESOLUTION: 'anatomical_model_resolution',
  CREDIT_EXPIRATION_WARNING: 'credit_expiration_warning',
  NOISE: 'noise',
  CENTRAL_DB: 'central_db',
  OPEN_STACK_MODE: 'open_stack_mode',
  MAX_GR: 'maxGr',
  RUN_ENABLED: 'run_enabled',
  TEST_SPURIOUS_ECHOES: 'testSpuriousEchoes',
  ISOCENTER: 'isocenter',
  ISOCENTER_LIMIT: 'isocenter_limit',
  OPEN_NOTIFICATION_MODE: 'open_notifications_mode',
  CENTRAL_DB_REPLICA: 'central_db_replica',
  CENTRAL_DB_USERNAME: 'central_db_username',
  CENTRAL_DB_PASSWORD: 'central_db_password',
  TEXT_ON_VIEWERS: 'text_on_viewers',
  OPEN_BASE_NOISE_WINDOW_MODE: 'open_base_noise_window_mode',
  KERNAL_THREADS: 'kernel_threads',
  KERNAL_BLOCKS: 'kernel_blocks',
  ISOTROPIC_GRID: 'isotropic_grid',
  SHOW_TISSUE_HOVER: 'show_tissue_hover',
  ACTIVE_INTERSECTIONS: 'active_intersections',
  COIL: 'coil',
  MOTION: 'motion',
  MOTION_ROT_ANGLE: 'motion_rot_angle',
  MOTION_ROT_FREQ: 'motion_rot_freq',
  MOTION_TRANS_MAGN: 'motion_trans_magn',
  MOTION_TRANS_FREQ: 'motion_trans_freq',
  MOTION_TRANS_AXIS: 'motion_trans_axis',
  DISTANCE_UNIT: 'distance_unit',
  TIME_UNIT: 'time_unit',
  OPEN_TISSUE_CHARACTERISTICS_WINDOW_MODE: 'open_tissues_characteristics_window_mode',
  DEACTIVE_GX: 'deactivateGx',
  DEACTIVE_GY: 'deactivateGy',
  DEACTIVE_GZ: 'deactivateGz',
  GRID_SIZE_OPTION: 'gridSizeOption',
  ACTIVE_CS: 'activate_cs',
  AUTO_RUN: 'auto_run',
  OPEN_KSPACE_MODE: 'open_kspace_mode',
  SIMULATION_MODE: 'simulationMode',
  ADVANCE_NOTIFICATIONS: 'advanced_notifications',
  EDUTOOL_VERSION: 'edutool_version',
  PULSE_SEQ_GENERATOR: 'pulse_seq_generator',
  SELECTED_REGION: 'selected_region',
  SUSCEPTIBILITY: 'susceptibility',
  DEFAULT_CARDIAC_PHASE: 'defaultCardiacPhase',
  PHYSIOLOGICAL_MOTION: 'physiologicalMotion',
  T2STAR: 't2Star',
  OVERWRITE_SIMULATION_SETTINGS: 'overwrite_simulation_settings',
  BREATHING_MODE: 'breathingMode',
  FUZZY_MODE: 'fuzzyMode',
  SIMULATOR_VERSION: 'simulatorVersion',
  B0_FIELD: 'b0field',
  MAX_GRADIENT_STRENGTH: 'maxGr',
  CUSTOM_TISSUE_MAGNETIC_PROPERTIES: 'customTissueMagneticProperties',
  BRAIN_CONDITION: 'brainStateMode', // User facing name is Brain Condition, but named brainStateMode in simulator
  HEART_CONDITION: 'heartCondition',
  ECG_GRAPH: 'ecgGraph',
  ACTIVATE_CONTRAST: 'activate_contrast',
  CONTRAST_CONCENTRATION: 'contrast_concentration',
  CONTRAST_VOLUME: 'contrast_volume',
  TIME_AFTER_CONTRAST: 'time_after_contrast',
} as const;

export default simulatorConfig;

export const simulatorConfigDefaults = {
  MAX_GR_DEFAULT_VALUE: 45,
  B0_FIELD_DEFAULT_VALUE: 1.5,
};

export const brainCondition = {
  HEALTHY: 'healthy',
  MILD_MS_LESIONS: 'mildMSlesions',
  MODERATE_MS_LESIONS: 'moderateMSlesions',
  SEVERE_MS_LESIONS: 'severeMSlesions',
  TUMOR: 'tumor',
};

export const contrastImaging = {
  DISABLED: 'ceiDisabled',
  ENABLED: 'ceiEnabled',
};

export const gridSize = {
  SIZE_1_MM: '1mm',
  SIZE_0_5_MM: '0p5mm',
  SIZE_OPTIMAL: 'optimal',
} as const;

export const breathingMode = {
  BREATHHOLD_FULL_EXHALE: 'breathhold_full_exhale',
  BREATHHOLD_FULL_INHALE: 'breathhold_full_inhale',
  FREE_BREATHING: 'free_breathing',
} as const;

export const heartCondition = {
  HEALTHY: 'healthy',
  MYOCARDIAL_INFARCTION: 'myocardialInfarction',
} as const;
